import axiosCall from './interceptor';
import URL from '../helper';

export const uploadInsert = async file => {
  let form = new FormData();
  form.append('fileType', 'pdf');
  form.append('inserts', file);
  const response = await axiosCall('post', `${URL.BASE_URL}inserts/upload`, form);
  return response.data;
};

export const fetchOrganizationInserts = async params => {
  const response = await axiosCall('get', `${URL.DESIGN_SYSTEM_URL}inserts`, params);
  return response.data;
};

export const deleteOrganizationInsert = async payload => {
  const response = await axiosCall('delete', `${URL.DESIGN_SYSTEM_URL}inserts?id=${payload.id}`);
  return response.data;
};

export const updateTemplateInsert = async (templateId, payload) => {
  const response = await axiosCall(
    'post',
    `${URL.DESIGN_SYSTEM_URL}inserts/addInserts/${templateId}`,
    payload,
  );
  return response.data;
};

export const updateInsertBusinessLogic = async payload => {
  const response = await axiosCall('put', `${URL.DESIGN_SYSTEM_URL}inserts/businessLogic`, payload);
  return response.data;
};
